import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference1: string }>;

export const DispatchcustomerReference1: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference1",
        customerReference1: props.parameter.customerReference1,
    });
};

export const chain = [DispatchcustomerReference1];

const setcustomerReference1 = createHandlerChainRunner(chain, "customerReference1");
export default setcustomerReference1;
